<template>
  <div class="container">
    <div v-if="!loggedIn">
      <ux-user-login @onsubmit="onSignIn" :error="authError"></ux-user-login>
    </div>
    <div v-else>
      <UxTagNav :tags="tabs" class="pill" @tagupdate="tagUpdate"></UxTagNav>
      <transition name="fade" mode="out-in">
        <component :is="current"></component>
      </transition>
    </div>
  </div>
</template>

<script>
import UxTagNav from "./UxTagNav";
import AdminUploads from "./AdminUploads";
import AdminSettingsPortfolio from "./AdminSettingsPortfolio";
import AdminSettingsSite from "./AdminSettingsSite";
import UxUserLogin from "./UxUserLogin";
export default {
  components: {
    UxUserLogin,
    UxTagNav,
    AdminUploads,
    AdminSettingsPortfolio,
    AdminSettingsSite
  },
  data() {
    return {
      current: "AdminUploads",
      filter: null,
      tabs: ["Uploads", "Portfolio", "Site"]
    };
  },
  created() {
    if (!this.$store.getters.uploads.length) {
      this.$store.dispatch("fetchUploads").then(() => {
        this.$store.dispatch("fetchTags");
      });
    }
  },
  computed: {
    uploads() {
      if (this.filter) {
        return this.$store.getters.uploads.filter(el => {
          return el.tags.includes(this.filter);
        });
      }
      return this.$store.getters.uploads;
    },
    loggedIn() {
      return this.$store.getters.isLoggedIn;
    },
    authError() {
      return this.$store.getters.authError;
    }
  },
  methods: {
    tagUpdate(arg) {
      if (arg == "Uploads") {
        this.current = "AdminUploads";
      }
      if (arg == "Portfolio") {
        this.current = "AdminSettingsPortfolio";
      }
      if (arg == "Site") {
        this.current = "AdminSettingsSite";
      }
    },
    updateFilter(arg) {
      this.filter = arg;
    },
    clearFilter() {
      this.filter = "";
    },
    onSignOut() {
      this.$store.dispatch("logOut");
    },
    onSignIn(data) {
      this.$store.dispatch("logIn", data);
    }
  }
};
</script>
<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
